export const CONTEXT_LINES = 3; // Show X lines before and after changes
export const MIN_COLLAPSE_SIZE = 10; // Only collapse if more than X lines (>=10)
export const INLINE_DIFF_THRESHOLD = 1000; // Threshold for inline diffing long lines

export const MAX_CONTENT_WIDTH = 1300;

export const COLLAPSED_SECTION_DIMENSIONS = {
  width: 116,
  height: 28,
  verticalGap: 18,
};

export const MAX_LOC = 10000; // maximum lines of code to show in diff, truncate otherwise

export const ESTIMATED_ROW_HEIGHT = 40;

// Where the target row should land within the viewport when jumping (0 = top, 1 = bottom).
export const JUMP_VIEW_POSITION = 0.3;

// Web fallback for ChangeSummaryPanel jump: poll the DOM until FlashList renders the row.
export const WEB_SCROLL_MAX_ATTEMPTS = 6;
export const WEB_SCROLL_POLL_INTERVAL_MS = 60;
export const DIFF_ROW_DOM_ID_PREFIX = 'diff-row-';

// Yellow flash overlay shown after a click-to-jump lands the row.
export const JUMP_HIGHLIGHT_DURATION_MS = 2500;
export const JUMP_HIGHLIGHT_COLOR = 'rgb(255, 235, 59)';
export const JUMP_HIGHLIGHT_BORDER_RADIUS = 8;

// Native peak opacity — there is no mix-blend-mode, so we stay translucent
// enough that text under the wash stays legible.
export const JUMP_HIGHLIGHT_NATIVE_OPACITY = 0.4;
